module.exports = __webpack_public_path__ + "images/carver49212070fe2357370aa85700e0e51acc.png";